import React from "react"
import PropTypes from "prop-types";
import Link from "../../Link";
import {
    Blogs,
    CustomerStorie,
    Docs,
    Events,
    ProductUpdates,
    ResourcesCenter,
    Whitepapers,
    Podcasts,
    Webinar,
    KnowledgeCenter
} from "../icons-header";
import { useTranslation, Trans } from "next-i18next";
import Image from "next/image";



const LearnDropdown = (props) => {
    const { t } = useTranslation("header");
    let dropdownItems = [
        {
            item1:[
                {
                    title:`${t('resourcesName.resourceCenter')}`,
                    link:'/resources/',
                    subtitle: '',
                    icon:<ResourcesCenter/>,
                },
                {
                    title:`${t('resourcesName.customerStories')}`,
                    link:'/customers/',
                    subtitle: '',
                    icon:<CustomerStorie/>,
                },
                {
                    title:`${t('resourcesName.productUpdates')}`,
                    link:'/product-updates/',
                    subtitle: '',
                    icon:<ProductUpdates/>,
                },
                {
                    title:`${t('resourcesName.ebooksWhitepaper')}`,
                    link:'/whitepaper/',
                    subtitle: '',
                    icon:<Whitepapers/>,
                },
                {
                    title:`${t('resourcesName.knowledgeCenter')}`,
                    link:'/knowledge/',
                    subtitle: '',
                    icon:<KnowledgeCenter/>,
                },

            ]
        },
    ]
    let dropdownItems1 = [
        {
            item1:[
                {
                    title:`${t('resourcesName.blogs')}`,
                    link:'/blog/',
                    subtitle: 'Latest Observability trends and insights.',
                    icon:<Blogs/>,
                },
                {
                    title:`${t('resourcesName.eventsWebinar')}`,
                    link:'/events/',
                    subtitle: '',
                    icon:<Events/>,
                },
                {
                    title:`${t('resourcesName.webinar')}`,
                    link:'/webinar/',
                    subtitle: '',
                    icon:<Webinar/>,
                },
                {
                    title:`${t('resourcesName.docs')}`,
                    link:'https://docs.middleware.io/',
                    subtitle: 'Comprehensive Middleware implementation guides.',
                    icon:<Docs/>,
                },
                {
                    title:`${t('resourcesName.podcasts')}`,
                    link:'/podcast/',
                    subtitle: 'Listen to Middleware experts.',
                    icon:<Podcasts/>,
                },

            ]
        },
    ]

    return <>
        <div className={'inner-wrapper product-menu solutions-menu learn-more'}>
            <div className={'d-flex sub-menu'}>
                <div className={'menus'}>
                    <div className={'d-flex'}>
                        {dropdownItems.map((mw_item, index) => {
                            return mw_item.item1 && Array.isArray(mw_item.item1) &&
                                <div className={'product-links'} key={index}>
                                    <div className={'product-drop'}>
                                        {mw_item.item1 && mw_item.item1.map((__item, __index) => {
                                            return <div key={__index}>
                                                {__item.link &&
                                                <Link href={__item.link} aria-label={'Middleware Dropdown'}
                                                              passHref>
                                                    <div className={'dropdown-menu'} onClick={props.onLinkClick}>
                                                            <span>{__item.icon}</span>
                                                            <div className="header-heading">
                                                                {__item.title}
                                                                {__item.isNew && <img src={"/images/product/new_features_dark.svg"} alt={"New Feature"} width={100} height={100} className={"new_features"}/>}
                                                            </div>
                                                    </div>
                                                </Link>
                                                }
                                            </div>
                                        })}
                                    </div>
                                </div>


                        })}
                        {dropdownItems1.map((mw_item, index) => {
                            return mw_item.item1 && Array.isArray(mw_item.item1) &&
                                <div className={'product-links'} key={index}>
                                    <div className={'product-drop'}>
                                        {mw_item.item1 && mw_item.item1.map((__item, __index) => {
                                            return <div key={__index}>
                                                {__item.link &&
                                                <Link href={__item.link} aria-label={'Middleware Dropdown'}
                                                              passHref>
                                                    <div className={'dropdown-menu'} onClick={props.onLinkClick}>
                                                            <span>{__item.icon}</span>
                                                            <div className="header-heading">

                                                                {__item.title}
                                                                {__item.isNew && <img src={"/images/product/new_features_dark.svg"} alt={"New Feature"} width={100} height={100} className={"new_features"}/>}
                                                            </div>
                                                    </div>
                                                </Link>
                                                }
                                            </div>
                                        })}
                                    </div>
                                </div>


                        })}

                    </div>
                </div>

                <div className={"menu-cta solution-page-menu"}>
                    {/* <p className="top-heading">Customer Proof</p> */}

                    <Image
                        src={"/images/community-menu-mw.png"}
                        alt="Solution Review"
                        width={465}
                        height={228}
                        sizes="(max-width: 991px) 90vw, 320px"
                        quality={90}
                    />

                    <p className="customer-quots">4,200+ engineers</p>

                    <p className="description">SREs, backend, and platform folks debugging together</p>

                    <Link key={"mw-register"} href={'https://community.middleware.io/'} className={'sign-up ahref-btn primary'} aria-label={'Middleware Community'} passHref target={"_blank"}>{t('logInSignUp.joinNow')}</Link>
                </div>
            </div>
        </div>
    </>
}
LearnDropdown.propTypes = {
    pageID: PropTypes.number,
    onLinkClick: PropTypes.any
}
export default LearnDropdown